import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "flex align-items-center gap-2" }
const _hoisted_3 = { class: "flex flex-column gap-4" }
const _hoisted_4 = { class: "flex flex-column gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "name"
}, "Name", -1)
const _hoisted_6 = { class: "flex flex-column gap-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "description"
}, "Description", -1)
const _hoisted_8 = { class: "flex flex-column gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "text-primary-50" }, "Permissions", -1)
const _hoisted_10 = { class: "font-bold text-primary mb-2" }
const _hoisted_11 = { class: "flex flex-wrap gap-3" }
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "flex align-items-center justify-content-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PTag = _resolveComponent("PTag")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _component_PCard = _resolveComponent("PCard")!
  const _component_PInputText = _resolveComponent("PInputText")!
  const _component_PCheckbox = _resolveComponent("PCheckbox")!
  const _component_PDialog = _resolveComponent("PDialog")!
  const _component_PConfirmDialog = _resolveComponent("PConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PCard, null, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_WTitle, { text: "Roles" }),
          _withDirectives(_createVNode(_component_PButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAdd())),
            icon: "pi pi-plus",
            rounded: "",
            size: "small"
          }, null, 512), [
            [
              _directive_tooltip,
              `Add a new role`,
              void 0,
              { left: true }
            ]
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_PDataTable, {
          alwaysShowPaginator: false,
          loading: _ctx.loading,
          rowHover: true,
          rows: 100,
          showGridlines: true,
          stripedRows: true,
          value: _ctx.list,
          "data-key": "id",
          paginator: "",
          size: "small"
        }, {
          empty: _withCtx(() => [
            _createTextVNode("No roles found.")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_PColumn, {
              field: "name",
              header: "Name",
              headerClass: "py-3",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", null, _toDisplayString(data.name), 1),
                  (data.is_system)
                    ? (_openBlock(), _createBlock(_component_PTag, {
                        key: 0,
                        severity: "info"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("System")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-wrap",
              field: "description",
              header: "Description",
              headerClass: "py-3"
            }),
            _createVNode(_component_PColumn, {
              header: "Permissions",
              headerClass: "py-3",
              style: {"width":"130px"}
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString((data.permissions || []).length), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-right",
              headerClass: "py-3",
              style: {"width":"100px"}
            }, {
              body: _withCtx(({ data }) => [
                _withDirectives(_createVNode(_component_PButton, {
                  disabled: data.is_system,
                  onClick: ($event: any) => (_ctx.openEdit(data)),
                  icon: "pi pi-pencil",
                  rounded: "",
                  severity: "success",
                  size: "small",
                  text: ""
                }, null, 8, ["disabled", "onClick"]), [
                  [
                    _directive_tooltip,
                    `Edit`,
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _withDirectives(_createVNode(_component_PButton, {
                  disabled: data.is_system,
                  onClick: ($event: any) => (_ctx.doDelete($event, data.id)),
                  icon: "pi pi-trash",
                  rounded: "",
                  severity: "danger",
                  size: "small",
                  text: ""
                }, null, 8, ["disabled", "onClick"]), [
                  [
                    _directive_tooltip,
                    `Delete`,
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "value"])
      ]),
      _: 1
    }),
    _createVNode(_component_PDialog, {
      header: _ctx.editing ? 'Edit role' : 'Add a new role',
      onHide: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeDialog())),
      modal: "",
      style: {"width":"40rem","max-width":"95vw"},
      visible: _ctx.showDialog,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_PInputText, {
              autocomplete: "off",
              id: "name",
              size: "small",
              modelValue: _ctx.item.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_PInputText, {
              autocomplete: "off",
              id: "description",
              size: "small",
              modelValue: _ctx.item.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.description) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedPermissions, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group.component,
                class: "border-1 surface-border border-round p-3 mb-2"
              }, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.prettify(group.component)), 1),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.permissions, (perm) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: perm.id,
                      class: "flex align-items-center gap-2"
                    }, [
                      _createVNode(_component_PCheckbox, {
                        inputId: 'perm-' + perm.id,
                        value: perm.id,
                        modelValue: _ctx.item.permissions,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.permissions) = $event))
                      }, null, 8, ["inputId", "value", "modelValue"]),
                      _createElementVNode("label", {
                        for: 'perm-' + perm.id
                      }, _toDisplayString(_ctx.prettify(perm.action)), 9, _hoisted_12)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_PButton, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editing ? _ctx.saveUpdates() : _ctx.doAdd())),
              label: "Save",
              size: "small"
            }),
            _createVNode(_component_PButton, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeDialog())),
              label: "Cancel",
              outlined: "",
              severity: "secondary",
              size: "small"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_PConfirmDialog)
  ], 64))
}